var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test"},[_c('div',{staticClass:"center fragment-root"},[_c('Banner',{staticClass:"bannerLogo"}),_c('ProjectLink')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }